import React from "react";
import "./AssessmentCompletedModal.scss";
import CheckCircleIcon from "../Assets/Images/CheckCircle.svg";
import CloseModalIcon from "../Assets/Images/closemodal.svg";

const AssessmentCompleteModal = ({ open, onClose, onViewResults }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="custom-modal">
        {/* Close icon positioned outside */}
        <button className="close-btn" onClick={onClose}>
          <img src={CloseModalIcon} alt="Check" className="close-icon" />
        </button>

        <div className="check-circle">
          <img src={CheckCircleIcon} alt="Check" className="check-icon" />
        </div>
        <h2 className="modal-title">
          You have already completed the assessment.
        </h2>
        <button className="view-results-btn" onClick={onClose}>
          View My Results
        </button>
      </div>
    </div>
  );
};

export default AssessmentCompleteModal;
